import { signInExistingAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInExistingAccount";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

signInExistingAccountStyles.signInExistingAccountTitle = {
    variant: "h4",
    css: css`
        margin-bottom: 20px;
    `,
};

signInExistingAccountStyles.signInButton = {
    css: css`
        border-radius: 25px;
        border: 1px solid ${getColor("warning")};
        background-color: ${getColor("warning")};
        > span {
            color: ${getColor("info.contrast")}!important;
            font-family: ${TYPOGRAPHY.fontFamily.base};
        }
        &:hover {
            border: 1px solid ${getColor("warning.contrast")};
            background-color: ${getColor("warning.contrast")};
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                null,
                null,
                null,
            ])}
    `,
};

signInExistingAccountStyles.forgotPasswordLink = {
    typographyProps: {
        size: 13,
    },
    css: css`
        span {
            color: ${getColor("primary")} !important;
        }
        &:hover {
            span {
                color: ${getColor("secondary")}!important;
                font-weight: ${TYPOGRAPHY.weight.baseBold};
            }
        }
        margin: 10px 0;
    `,
};
